<div class="cheat-sheet-content">
  <!-- Search -->
  <div class="search-bar">
    <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
    <input
      type="text"
      [value]="searchQuery()"
      (input)="onSearch($any($event.target).value)"
      placeholder="Search players..."
      class="search-input"
    />
  </div>

  <!-- View Mode Toggle -->
  <div class="view-mode-toggle">
    <button
      class="view-mode-btn"
      [class.active]="viewMode() === 'all'"
      (click)="setViewMode('all')">
      All Players
    </button>
    <button
      class="view-mode-btn watchlist-btn"
      [class.active]="viewMode() === 'watchlist'"
      (click)="setViewMode('watchlist')">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
      Watchlist
      @if (watchlistCount() > 0) {
        <span class="tab-count">{{ watchlistCount() }}</span>
      }
    </button>
  </div>

  <!-- Filters Row -->
  <div class="filters-row">
    <div class="position-tabs">
      @for (pos of positions; track pos) {
        <button
          class="position-tab"
          [class.active]="activePosition() === pos"
          (click)="setPosition(pos)">
          {{ pos }}
          <span class="tab-count">{{ positionCounts()[pos] || 0 }}</span>
        </button>
      }
    </div>
    <select
      class="ranking-select"
      [value]="rankingMode()"
      (change)="onRankingModeChange($any($event.target).value)">
      @for (opt of rankingOptions; track opt.value) {
        <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  </div>

  <!-- Player List -->
  <div class="player-list">
    @if (isLoading() && allPlayers().length === 0) {
      <div class="loading-state">Loading players...</div>
    } @else if (filteredPlayers().length === 0) {
      <div class="empty-state">
        @if (viewMode() === 'watchlist') {
          @if (watchlistCount() === 0) {
            No players on your watchlist yet
          } @else {
            No watchlisted {{ activePosition() === 'ALL' ? '' : activePosition() + ' ' }}players available
          }
        } @else if (searchQuery()) {
          No players match "{{ searchQuery() }}"
        } @else {
          No available players
        }
      </div>
    } @else {
      @for (player of filteredPlayers(); track player.id) {
        <div class="player-row" (click)="selectPlayer(player)">
          <div class="player-main">
            <span class="player-rank">
              @if (getPlayerRank(player); as rank) {
                {{ rank }}
              } @else {
                --
              }
            </span>
            <div class="player-photo">
              @if (player.photo) {
                <img [src]="player.photo" [alt]="player.first_name + ' ' + player.last_name" class="player-headshot" loading="lazy" (error)="onPhotoError($event, player)" />
              } @else {
                <span class="player-photo-initials">{{ player.first_name[0] }}{{ player.last_name[0] }}</span>
              }
            </div>
            <div class="player-info">
              <span class="player-name">{{ player.first_name }} {{ player.last_name }}</span>
              <span class="player-meta">
                <span class="player-position-inline" [attr.data-pos]="normalizePosition(player.position)">{{ player.position }}@if (player.positionalRank) { #{{ player.positionalRank }}}</span>
                {{ player.team }}
              </span>
            </div>
          </div>
          <div class="player-value">
            @if (getPlayerValue(player); as val) {
              ${{ val }}
            }
          </div>
          <button
            class="star-btn"
            [class.active]="watchlistPlayerIds().has(player.id)"
            (click)="toggleWatchlist($event, player)"
            [title]="watchlistPlayerIds().has(player.id) ? 'Remove from watchlist' : 'Add to watchlist'">
            <svg width="14" height="14" viewBox="0 0 24 24"
              [attr.fill]="watchlistPlayerIds().has(player.id) ? 'currentColor' : 'none'"
              stroke="currentColor" stroke-width="2">
              <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
            </svg>
          </button>
        </div>
      }
    }
  </div>
</div>
